var React = require('react');

function CircleSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.5 11C8.53757 11 11 8.53757 11 5.5C11 2.46243 8.53757 0 5.5 0C2.46243 0 0 2.46243 0 5.5C0 8.53757 2.46243 11 5.5 11Z"}));
}

CircleSolid.defaultProps = {"width":"11","height":"11","viewBox":"0 0 11 11","fill":"currentColor"};

module.exports = CircleSolid;

CircleSolid.default = CircleSolid;
